module.exports = __webpack_public_path__ + "static/cmac-9bc06f5ad4e37db1add6f83b91e6e68d.jpeg";